import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { modulemedia } from 'src/app/models/module/moduledetails';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import Player from 'video.js/dist/types/player';
import { offlineVideoSupported } from 'src/app/services/offline/offline-video-capability';
import { OfflineVideoPlaybackService } from 'src/app/services/offline/offline-video-playback.service';
import { OfflineDbService } from 'src/app/services/offline/offline-db.service';
import { MediaRecord } from 'src/app/services/offline/offline-db.types';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { getCurrentSchoolSubdomain, getCurrentUserId } from 'src/app/services/offline/offline-cache-key';
import { OfflineMediaService, RenditionManifestEntry, RenditionStatusName } from 'src/app/services/offline/offline-media.service';
import { OfflineSessionService } from 'src/app/services/offline/offline-session.service';
import { OfflineEntitlementService } from 'src/app/services/offline/offline-entitlement.service';
import { UtilService } from 'src/app/services/util.service';
import { canSaveForOffline } from 'src/app/services/offline/offline-feature-gate';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OfflineConnectivityService } from 'src/app/services/offline/offline-connectivity.service';

declare var $: any;
//import { Hls } from '../../../assets/js/hls';
//declare const Hls: any;

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class ModuleMediaComponent implements OnInit, OnDestroy, AfterViewInit {

  media: modulemedia = new modulemedia();
  moduleid: number = 0;
  uploadid: string = '';
  legacy: boolean = false;
  classid: number = 0;//for legacy stuff
  legacysno: number = 0;
  @ViewChild('video') video: ElementRef;
  @ViewChild('audio') audio: ElementRef;
  @ViewChild('mediacontainer') mediacontainer: ElementRef;
  player: Player = null;

  // Offline mode P5 — download-for-offline UI state. offlineDownloadEligible gates whether
  // the download control renders at all (flag on, not admin, entitlement covers this
  // module) — cheap to check, keeps this inert for everyone until the whole feature is on.
  offlineDownloadEligible = false;
  offlineDownloadSupported = false;
  renditions: RenditionManifestEntry[] = [];
  // 'notrequested' -> offer a Prepare button; 'building' -> tell them to come back;
  // 'noteligible' -> show nothing at all and never ask the server again.
  renditionStatus: RenditionStatusName = 'notrequested';
  preparingRenditions = false;
  selectedRenditionIndex = 0;
  isDownloadedOffline = false;
  // Set only when we are actually playing the saved copy. It is an iframe URL, not a video
  // src - see offline-video-playback.service.ts getPlaybackUrl for why it has to be.
  offlinePlayerUrl: SafeResourceUrl | null = null;
  // The saved copy is for an older processing pass than what the server now serves. We do not
  // silently re-download a video - that is the user's bandwidth - we offer it.
  offlineCopyStale = false;
  downloading = false;
  downloadPercent = 0;
  config = {
    controls: true,
    autoplay: false,
    fluid: false,
    loop: false,
    sources: [],
    responsive: true,
    playbackRates: [0.5, 1, 1.5, 2],
    controlBar: {
        volumePanel: {inline: false},
        pictureInPictureToggle: false,
        fullscreenToggle: true,
        remainingTimeDisplay:{
          displayNegative: false
        }
    },
    html5:{
      vhs:{
        limitRenditionByPlayerDimensions: false,
        useDevicePixelRatio: true
      }
    }
    // width: 700,
    // height: 500,
    // aspectRatio: "1:1",
    // liveui: true,
    // children: {
    // bigPlayButton: true,
    // controlBar: {
    //   volumePanel: {
    //     inline: false
    //   },
    //   ProgressControl: {
    //     SeekBar: {
    //       PlayProgressBar: true
    //     }
    //   }
    //   // }
    // },
    // playbackRates: [0.5, 1, 1.5, 2],
  };
  constructor(
    private activatedroute: ActivatedRoute,
    private modulemanager: ModulemanagementService,
    private offlineVideoPlayback: OfflineVideoPlaybackService,
    private offlineDb: OfflineDbService,
    private useraccessservice: UseraccessserviceService,
    private offlineMedia: OfflineMediaService,
    private offlineSession: OfflineSessionService,
    private offlineEntitlement: OfflineEntitlementService,
    private util: UtilService,
    private headerinfo: ComponentheaderService,
    private sanitizer: DomSanitizer,
    private connectivity: OfflineConnectivityService,
  ) { }
  async ngAfterViewInit() {
    //debugger;
    // Offline playback (docs/offline-mode-plan.md P5) — genuinely checked first now, before
    // the network call below, not just before video.js. moduleid/uploadid are already known
    // from route params, so this needs nothing from the server. Previously getSingleMedia()
    // ran unconditionally first, so a saved video could never actually play while offline —
    // that network call has no offline fallback and would hang/fail before this was ever
    // reached. Online behaviour with no local copy is completely untouched below: this only
    // short-circuits when there is actually something downloaded to play.
    if (!this.legacy) {
        this.isDownloadedOffline = await this.hasOfflineCopy();

        // The saved copy is a FALLBACK for having no network, not a replacement for it.
        // Preferring it whenever it existed meant any fault in the offline playback path
        // also broke playback for people who were online and had a perfectly good stream
        // available - which is exactly what happened.
        if (this.isDownloadedOffline && this.connectivity.currentState !== 'online') {
            if (await this.tryPlayOffline()) {
                return;
            }
        }

        // Online with a saved copy: get the worker installed and let the browser run its
        // update check now, while a network still exists. Nothing else on the online path
        // touches the worker, so without this it could never install or update - it would
        // first be needed at the exact moment it can no longer be fetched.
        if (this.isDownloadedOffline && this.connectivity.currentState === 'online' && offlineVideoSupported()) {
            this.offlineVideoPlayback.ensureReady();
        }
    }

    if(!this.legacy){
        this.media = await this.modulemanager.getSingleMedia(this.moduleid, this.uploadid).toPromise();
    }else{
        this.media = await this.modulemanager.getSingleLegacyMedia(this.classid, this.legacysno).toPromise();
        //debugger;
    }

    //debugger;
    if(this.media.type.startsWith('video')){
        await this.initOfflineDownloadEligibility();

        // Loaded on demand — video.js and its HLS quality-selector plugin are only
        // needed on this page, not on every route that happens to eagerly import media.component.
        const videojs = (await import('video.js')).default;
        await import('videojs-hls-quality-selector');

        this.config.sources = [];
        const video: any = this.video.nativeElement;
        if (this.media.hlsmediaurl) {
            this.config.sources.push({src: this.media.hlsmediaurl, type: 'application/vnd.apple.mpegurl'});
        }
        else{
            this.config.sources.push({src: this.media.mediaurl, type: this.media.type});
        }

        this.player = videojs(this.video.nativeElement, this.config, () => {
            const container = this.mediacontainer.nativeElement.querySelector('.video-js');
            
            if(container){
                $(container).css('display', '');
            }
            // console.log('player ready! id:', el);
      
            // // print version information at startup
            // var msg = 'Using video.js ' + videojs.VERSION +
            //   ' with videojs-record ' + videojs.getPluginVersion('record') +
            //   ' and recordrtc ' + RecordRTC.version;
            // videojs.log(msg);
            //this.loadHlsVideo(this.media.hlsmediaurl, this.media.mediaurl);
        });
        
        if (this.media.hlsmediaurl){
          const player: any = this.player;
          player.hlsQualitySelector({
            displayCurrentQuality: true,
          });
        }
    }
    else{
        this.audio.nativeElement.src = this.media.mediaurl;
    }

    if(this.media && this.media.type && this.media.type.startsWith('audio')){
        $(self.frameElement).css('height', '60px');//.style.height = '60px';
    }
  }

  // Returns true (and leaves the plain native <video> playing) when a local rendition of
  // this video exists and this browser supports the offline playback mechanism. video.js is
  // never invoked on this path — the element already has native `controls`, and video.js's
  // own source handling has no reason to understand our decrypted-chunk stream.
  // The note embeds this component as a Quill MediaBlot iframe, and .mediaiframe is pinned to
  // aspect-ratio 16/9 (styles.css) - sized to the video and nothing else. Anything rendered
  // below the video, which is every offline control, falls outside that box and is invisible.
  // Same-origin iframe, so we can grow our own frame to fit; the audio branch above already
  // does exactly this with frameElement.
  private syncFrameHeight(): void {
    try {
      const frame: HTMLIFrameElement | null = window.frameElement as HTMLIFrameElement;
      if (!frame) return; // rendered standalone, not embedded - nothing to resize

      // Let the layout settle after the controls render, then match the real content height.
      setTimeout(() => {
        const content = this.mediacontainer?.nativeElement as HTMLElement;
        if (!content) return;
        const height = content.scrollHeight;
        if (height > 0) {
          frame.style.height = `${height}px`;
          frame.style.aspectRatio = 'auto'; // otherwise the 16/9 rule keeps winning
          frame.style.maxHeight = 'none';
        }
      }, 0);
    } catch (err) {
      console.error('[offline] could not resize media frame', err);
    }
  }

  // Just "is there a local copy" - drives the Available offline badge and hides the download
  // control. Says nothing about which source we play from.
  private async hasOfflineCopy(): Promise<boolean> {
    return !!(await this.findOfflineManifest());
  }

  private async findOfflineManifest(): Promise<MediaRecord | undefined> {
    if (this.legacy) return undefined; // legacy media was never covered by the P5 download path
    if (!offlineVideoSupported()) return undefined;
    // Deliberately NOT gated on isInstalledPwa(). A video already downloaded to this device
    // plays wherever the student opens it; only ACQUIRING it needs the installed app
    // (offline-feature-gate.ts). Gating this would have made a saved video unplayable on any
    // browser whose display-mode we failed to recognise.

    const school = getCurrentSchoolSubdomain();
    const user = getCurrentUserId(this.useraccessservice.getCurrentUserToken());
    if (!school || !user) return undefined;

    const resourceId = `${this.moduleid}:${this.uploadid}`;
    return this.offlineDb.findMediaManifest(school, user, resourceId).catch(() => undefined);
  }

  // Points an in-scope iframe at the saved copy. Returns false on any failure so the caller
  // can fall through to the normal online path.
  private async tryPlayOffline(): Promise<boolean> {
    const manifest = await this.findOfflineManifest();
    if (!manifest) return false;

    const school = getCurrentSchoolSubdomain();
    const user = getCurrentUserId(this.useraccessservice.getCurrentUserToken());
    if (!school || !user) return false;

    try {
      const resourceId = `${this.moduleid}:${this.uploadid}`;
      const url = await this.offlineVideoPlayback.getPlaybackUrl(school, user, resourceId, manifest.rendition, manifest.version);
      this.offlinePlayerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.syncFrameHeight();
      return true;
    } catch (err) {
      console.error('[offline] video playback setup failed, falling back to online', err);
      this.offlinePlayerUrl = null;
      return false;
    }
  }

  // Populates renditions[] for the download control — gated on the flag being on, this user
  // not being an admin (D5), and a valid entitlement covering this module. Never throws;
  // leaves the download control simply absent on any failure.
  private async initOfflineDownloadEligibility(): Promise<void> {
    try {
      this.offlineDownloadSupported = offlineVideoSupported();
      const schoolToggle = this.offlineSession.current?.offlineEnabled ?? false;
      const flagOn = canSaveForOffline(schoolToggle);
      const isAdmin = this.offlineSession.current?.isAdmin ?? true; // fail closed (treat as admin) if unknown
      if (!flagOn || isAdmin || !this.offlineDownloadSupported) return;

      const entitlement = await this.offlineEntitlement.getValid();
      if (!entitlement || !entitlement.moduleIds.includes(this.moduleid)) return;

      const resp = await this.offlineMedia.getRenditions(this.moduleid, this.uploadid);
      this.renditions = resp.renditions;
      this.renditionStatus = resp.status;
      this.offlineDownloadEligible = this.renditions.length > 0;

      if (this.isDownloadedOffline) {
        const saved = await this.findOfflineManifest();
        // Must match findStaleSavedVideos' rule exactly, or the page and the reconnect toast
        // disagree about the same video. 'unversioned' on either side means we cannot tell.
        const comparable = !!saved && saved.version !== 'unversioned' && resp.version !== 'unversioned';
        this.offlineCopyStale = comparable && saved.version !== resp.version;
      }

      this.syncFrameHeight();
    } catch (err) {
      console.error('[offline] rendition eligibility check failed', err);
    }
  }

  // Explicitly asks the server to build the offline copies. Only reachable from the button, so
  // opening the page never schedules transcode work the way it used to.
  async prepareForOffline(): Promise<void> {
    if (this.preparingRenditions) return;
    this.preparingRenditions = true;
    try {
      this.renditionStatus = await this.offlineMedia.requestRenditions(this.moduleid, this.uploadid);
    } catch (err) {
      console.error('[offline] could not request offline copies', err);
    } finally {
      this.preparingRenditions = false;
    }
  }

  async downloadForOffline(): Promise<void> {
    const rendition = this.renditions[this.selectedRenditionIndex];
    if (!rendition || this.downloading) return;

    const school = getCurrentSchoolSubdomain();
    const user = getCurrentUserId(this.useraccessservice.getCurrentUserToken());
    if (!school || !user) return;

    this.downloading = true;
    this.downloadPercent = 0;
    try {
      const resourceId = `${this.moduleid}:${this.uploadid}`;

      // Drop whatever is already stored for this video first. Re-saving at a new version (or a
      // different quality) writes under a different key, so without this the previous copy's
      // chunks would stay on the device forever.
      const existing = await this.findOfflineManifest();
      if (existing) {
        await this.offlineMedia.deleteStoredRendition(school, user, resourceId, existing.rendition, existing.version);
      }

      await this.offlineMedia.downloadAndStore(rendition.url, school, user, resourceId, rendition.label, rendition.version, 'video/mp4', (received, total) => {
        this.downloadPercent = total ? Math.floor((received / total) * 100) : 0;
        this.headerinfo.setLoadingProgress(this.downloadPercent);
      });
      // Put the worker (and its precached player page) in place now. This is the last
      // moment we are guaranteed a network before the saved copy is needed.
      await this.offlineVideoPlayback.ensureReady();
      this.isDownloadedOffline = true;
      this.offlineCopyStale = false;
      this.syncFrameHeight();
    } catch (err) {
      console.error('[offline] video download failed', err);
    } finally {
      this.downloading = false;
    }
  }

  ngOnInit() {
    //debugger;
    document.body.style.overflow = 'hidden';
    this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid);
    this.uploadid = this.activatedroute.snapshot.queryParams.uploadid;
    this.legacy = this.activatedroute.snapshot.data.legacy;
    this.classid = parseInt(this.activatedroute.snapshot.params.classid);
    this.legacysno = parseInt(this.activatedroute.snapshot.queryParams.sno);
  }

  ngOnDestroy() {
    // destroy player
    if (this.player) {
      this.player.dispose();
    }
  }

  loadHlsVideo(hlsurl, nonhlsurl) {
    const video = this.video.nativeElement;
    //const audio = this.audio.nativeElement;
    if (video) {
      //debugger;
        // if (Hls.isSupported()) {
        //     let m3u8url = hlsurl;

        //     if (m3u8url.endsWith('.m3u8')) {
        //         let hls = new Hls();
        //         let resolutiondiv;
        //         console.log('hls url: ' + m3u8url);
        //         //debugger;
        //         hls.loadSource(m3u8url);
        //         hls.attachMedia(video);
        //         hls.on(Hls.Events.MANIFEST_PARSED, function () {
        //             //video.play();
        //             //debugger;
        //             let videoparent = video.parentElement;

        //             let qualitycontainer = document.createElement('div');
        //             qualitycontainer.setAttribute('class', 'video_quality');
        //             let dropdown = document.createElement('div');
        //             dropdown.setAttribute('class', 'btn-group');
        //             let r = Math.random().toString(36).substring(7);
        //             //console.log("random", r);

        //             let dropdownbuttonid = `dropdown_${r}`;

        //             let qualitybutton = document.createElement('button');
        //             qualitybutton.setAttribute('id', dropdownbuttonid);
        //             qualitybutton.setAttribute('class', 'fas fa-cog videoqualitybutton dropdown');
        //             qualitybutton.setAttribute('type', 'button');
        //             qualitybutton.setAttribute('data-toggle', 'dropdown');
        //             qualitybutton.setAttribute('aria-haspopup', 'true');
        //             qualitybutton.setAttribute('aria-expanded', 'false');

        //             dropdown.appendChild(qualitybutton);

        //             let menu = document.createElement('ul');
        //             menu.setAttribute('class', 'dropdown-menu hls_quality_dropdown_menu');
        //             menu.setAttribute('role', 'menu');
        //             menu.setAttribute('aria-labelledby', dropdownbuttonid);

        //             //debugger;
        //             //hls.levelController.levels[0].width
        //             for (let i = hls.levelController.levels.length - 1; i >= -1; i--) {
        //                 let li = document.createElement('li');
                        
        //                 let a = document.createElement('a');
        //                 a.setAttribute('class', 'dropdown-item hls_quality_option');
        //                 let level = hls.levelController.levels[i];
        //                 if (i >= 0) {
        //                     a.innerText = `${level.width} x ${level.height}`;
        //                 }
        //                 else {
        //                     a.innerText = 'Auto';
        //                 }
        //                 a.setAttribute('href', 'javascript:void(0)');
        //                 a.onclick = function () {
        //                     //hls.levelController.manualLevel = i;
        //                     hls.currentLevel = i;
        //                     //set url to level.url
        //                     //let videotime = video.currentTime;
        //                     ////debugger;
        //                     ////hls.loadSource(level.url[0]);
        //                     //hls.destroy();
        //                     //hls = new Hls();
        //                     ////hls.loadSource(level.url[0]);
        //                     //debugger;
        //                     //hls.attachMedia(video);
        //                     //hls.on(Hls.Events.MANIFEST_PARSED, () => {
        //                     //    //video.currentTime = videotime;
        //                     //    //video.play();
        //                     //});
                            
        //                 };
        //                 li.appendChild(a);
        //                 menu.appendChild(li);
        //             }

        //             resolutiondiv = document.createElement('div');
        //             resolutiondiv.setAttribute('class', 'hls_quality_div');

                    
        //             //resolutiondiv.innerText = 

        //             dropdown.appendChild(menu);

        //             qualitycontainer.appendChild(dropdown);
        //             qualitycontainer.appendChild(resolutiondiv);
        //             videoparent.appendChild(qualitycontainer);
        //         });
        //         var displayResolution = function (levelno) {
        //             let level = hls.levelController.levels[levelno];
        //             let resolution = `${level.width} x ${level.height}`;
        //             resolutiondiv.innerText = resolution;
        //         }
        //         hls.on(Hls.Events.LEVEL_SWITCHED, function (event, args) {
        //             //debugger;
        //             let levelno = args.level;
        //             displayResolution(levelno);
        //         });
        //         hls.on(Hls.Events.LEVEL_UPDATED, function (event, args) {
        //             //debugger;
        //             let levelno = args.level;
        //             displayResolution(levelno);
        //         });
        //         video.addEventListener('canplay', function () {
        //             if (!this.hasAttribute('userclickedplay') && !this.hasAttribute('canplayfired')) {
        //                 hls.stopLoad();
        //                 this.setAttribute('stoppedloading', '');// = true;
        //             }
        //             this.setAttribute('canplayfired', '');// = true;
        //         });
        //         video.addEventListener('play', function () {
        //             this.setAttribute('userclickedplay', '');// = true;
        //             if (this.hasAttribute('stoppedloading')) {
        //                 hls.startLoad();
        //                 this.removeAttribute('stoppedloading');// = false;
        //             }
        //         });
                
        //         //<div class="video_quality"><button class="fa fa-gear videoqualitybutton"></button></div>
        //     }
        //     else {
        //         video.src = m3u8url;
        //     }
        // }
        //else 
        // if (video.canPlayType('application/vnd.apple.mpegurl')) {
        //     video.src = hlsurl;
        // }
        // else {
        //     video.src = nonhlsurl;
        // }
    }
}

}
